import { notification } from "antd";
import omitDeep from "omit-deep-lodash";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import { UPDATE_PRICER } from "utils/api/graphql/mutations/pricers";
import { PRICER, PRICERS } from "utils/api/graphql/queries/pricers";
import { PRICER_TYPES, SCREENS } from "utils/constants";
import View from "./View";

const Detail = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PRICER);
  const ERRORS = t("ERRORS", { returnObjects: true });
  const navigate = useNavigate();
  const { id } = useParams();
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.PRICERS.LIST.path);
  const [updatePricer] = useMutation(UPDATE_PRICER, {
    refetchQueries: [
      {
        query: PRICERS,
        awaitRefetchQueries: true,
      },
    ],
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.ADMIN.PRICERS.LIST.path);
    },
    onError: () => notification.error({ message: ERRORS.DATE_CONFLICT }),
  });
  const { data, loading, error } = useQuery(PRICER, {
    variables: { where: { id } },
  });
  const onSubmit = ({ prices, dates, ...values }) => {
    const [startDate, endDate] = dates;
    return updatePricer({
      variables: {
        where: {
          id,
        },
        data: {
          ...values,
          type: PRICER_TYPES.DB,
          startDate: startDate.startOf("day"),
          endDate: endDate.endOf("day"),
          prices: prices.map(
            ({
              costs,
              departments,
              socialRegime,
              commission,
              beneficiaryType,
            }) => ({
              costs: JSON.parse(costs),
              socialRegime,
              departments,
              beneficiaryType,
              commission,
            })
          ),
        },
      },
    });
  };

  if (loading || error) return <Loading />;

  return (
    <View
      onSubmit={onSubmit}
      data={omitDeep(data.pricer, "__typename")}
      cancel={cancel}
    />
  );
};

export default Detail;
